// "Dónde se usa": módulo + título del dueño + propiedades (en MAYÚSCULAS).
import React from "react";
import { Tag, Typography } from "antd";
import { formatPropertyNames } from "../../../utils/propertyDisplay";
import type { Archivo } from "../../../services/almacenamiento.api";

const { Text } = Typography;

const DuenoCell: React.FC<{ archivo: Pick<Archivo, "usos" | "carpeta" | "estado"> }> = ({
  archivo,
}) => {
  const [primero, ...resto] = archivo.usos;
  if (!primero) {
    return (
      <div className="alm-dueno">
        <Text type="secondary">Sin dueño</Text>
        <Text type="secondary" className="alm-dueno-sub">
          Carpeta {archivo.carpeta}
        </Text>
      </div>
    );
  }
  const propiedades = formatPropertyNames(primero.propiedades);
  return (
    <div className="alm-dueno">
      <div>
        <Tag color="purple" style={{ marginInlineEnd: 6 }}>
          {primero.etiquetaModulo}
        </Tag>
        {resto.length > 0 && (
          <Text type="secondary" className="alm-dueno-sub">
            +{resto.length} {resto.length === 1 ? "lugar más" : "lugares más"}
          </Text>
        )}
      </div>
      <Text className="alm-dueno-titulo" ellipsis={{ tooltip: primero.titulo }}>
        {primero.titulo || `Registro #${primero.filaId}`}
      </Text>
      {propiedades.length > 0 && (
        <Text type="secondary" className="alm-dueno-sub">
          {propiedades.join(" · ")}
        </Text>
      )}
    </div>
  );
};

export default DuenoCell;
